<template>
    <v-container fluid style="max-width:1700px">

        <v-row>
            <v-col cols="12" class="d-flex flex-column">
                <v-card>
                    <div class="card-title">
                        {{ $t('KsaResults')}}
                    </div>
                    <v-card-text>
                        <v-row>
                            <v-col cols="6">
                                <v-autocomplete dense outlined :items="surveys" v-model="selectedSurveys" item-value="id" item-text="nameAr" :label="$t('Surveys')">
                                    <template v-slot:item="{ item }">
                                        {{ item.id }} -  {{ isArabicLanguage ? item.nameAr : item.nameEn }}
                                    </template>
                                </v-autocomplete>
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete searchable dense
                                                multiple
                                                clearable
                                                outlined
                                                v-model="selectedMunicipalityItems"
                                                :items="municipalityItems"
                                                item-value="id"
                                                item-text="name"
                                                :label="$t('sharedWithMunicipality')">
                                    <template v-slot:prepend-item>
                                        <v-list-item @click="selectAllItems">
                                            <v-list-item-content>{{ $t('SelectAll') }}</v-list-item-content>
                                        </v-list-item>
                                    </template>
                                    <template v-slot:item="{ item }">
                                        <v-list-item-content>
                                            <h4>{{ item.name }}</h4>
                                        </v-list-item-content>
                                    </template>
                                    <template v-slot:selection="{ item }">
                                        <v-chip small :key="item.id" close @click:close="removeItem(item.id)">
                                            {{ item.name }}
                                        </v-chip>
                                    </template>
                                </v-autocomplete>
                            </v-col>

                            <v-col md="6" cols="12">
                                <!-- Filter by Year -->
                                <v-menu v-model="yearMenu" clearable
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="290px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field v-model="selectedYear" outlined dense clearable
                                                      :label="$t('Year')"
                                                      readonly
                                                      v-bind="attrs"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker v-model="yearPicker" :max="maxDate"
                                                   type="year" @click:year="selectYear($event)"></v-date-picker>
                                </v-menu>

                            </v-col>
                            <v-col md="6" cols="12">
                                <!-- Filter by Quarter (using Calendar) -->
                                <v-select v-model="selectedQuarter" outlined dense clearable
                                          :items="quarters"
                                          :label="$t('Quarter')"></v-select>
                            </v-col>
                            <v-col cols="12">
                                <v-btn color="secondary" class="my-1 ms-3 float-end" @click="clear()" :loading="loading">
                                    {{$t('Clear') }}
                                </v-btn>
                                <v-btn color="primary" class="my-1 float-end" @click="loadDemographics" :loading="loading">
                                    {{$t('Apply') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-row v-for="q in filterquestions" :key="q.id">
                            <v-col>
                                <v-select dense v-model="q.selectedValue" clearable outlined :items="q.options" :label="q.title" item-text="name" item-value="id"></v-select>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>

            </v-col>
            <v-col v-for="q in filteredQuestions" :key="q.id" cols="12" :md="columSize(q.resultTypeId)" class="d-flex flex-column">
                <!-- Educational Level Chart -->
                <!-- Age Group Chart -->


                <template v-if="q.resultTypeId === ResultTypes.PreCommunication">
                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprecommunicationresults"></v-skeleton-loader>
                    <PreCommunicationChart v-model="q.precommunicationresults" v-if="!loadingprecommunicationresults && q.precommunicationresults" />
                </template>


                <template v-else-if="q.resultTypeId === ResultTypes.CommunicationReason">
                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingcomreasons"></v-skeleton-loader>
                    <CommunicationReasonChart v-model="q.comreasons" v-if="!loadingcomreasons && q.comreasons" />
                </template>



            </v-col>

            <v-col cols="12" v-if="result.length > 0 || loading" class="d-flex flex-column">
                <div class="chart-title mt-0">{{$t('Municipalities')}}</div>
                <v-card style="background: #efeded">
                    <v-card-text>

                        <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loading"></v-skeleton-loader>

                        <MunicipalitiesChart v-model="amanatData" v-if="!loading" @selectMunicipality="selectMunicipality" />
                    </v-card-text>
                </v-card>
            </v-col>
            <!--<v-col cols="12" v-if="resultregion.filter(x=>x.count>0).length>0 || loadingregion" class="d-flex flex-column">
        <div class="chart-title mt-0">{{$t('Regions')}}</div>
        <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingregion"></v-skeleton-loader>
        <RegionsChart v-if="!loadingregion" v-model="resultregion" />

    </v-col>-->
            <v-col cols="12" v-if="spiderResults.filter(x=>x.count>0).length>0 || loadingspiderResults" class="d-flex flex-column">
                <div class="chart-title mt-0">{{ $t('SpiderChart') }}</div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingspiderResults"></v-skeleton-loader>
                <SpiderChart v-model="spiderResults" v-if="!loadingspiderResults" />
            </v-col>
            <v-col cols="12" v-if="(heatMap.filter(x=>x.count>0).length>0 || loadingheatMap) && selectedMunicipalityItems.length == 0" class="d-flex flex-column">
                <v-card class="elevation-5 mt-4 rounded-lg" min-height="357">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingheatMap"></v-skeleton-loader>
                    <v-card-text v-if="!loadingheatMap">
                        <v-simple-table border="1">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th style="min-width:150px">
                                            <span>
                                                متوسط الرضا عن الجهود البلدية لمعالجة مظاهر التشوه البصري على مستوى المملكة
                                            </span><br /><img src="/ksa.jpg" width="50" />
                                        </th>
                                        <!-- Group headers by municipalityName -->
                                        <th v-for="(municipality, index) in groupedData"
                                            :key="'header-' + index"
                                            class="text-center">

                                            <div>{{ municipality[0].municipalityName }}</div><br />
                                            <v-img :src="municipality[0].logo" max-width="50" max-height="50"></v-img>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(option, ind) in groupedDataById" :key="'row-' + ind">
                                        <!-- Rows by ids, percentages -->
                                        <td>{{option[0].id}}<br />({{getAveragePercentageById(option[0].id)}}%)</td>
                                        <td v-for="(municipality, index) in groupedData"
                                            :key="'cell-' + index"
                                            class="text-center" :style="{ backgroundColor: getBackgroundColor(getAveragePercentage(municipality[0].municipalityName, option[0].id)), color: getTextColor(getAveragePercentage(municipality[0].municipalityName, option[0].id)) }">

                                            {{ getAveragePercentage(municipality[0].municipalityName, option[0].id) }}%

                                        </td>
                                    </tr>

                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="(groupedDataIntishar.length>0 || loadingheatMapIntishar) && selectedMunicipalityItems.length == 0" class="d-flex flex-column">
                <v-card class="elevation-5 mt-4 rounded-lg" min-height="357">
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingheatMapIntishar"></v-skeleton-loader>
                    <v-card-text v-if="!loadingheatMapIntishar">
                        <v-simple-table border="1">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th style="min-width:150px">
                                            <span style="color: rgb(255,150,125)">
                                                متوسط انتشار مظاهر التشوه
                                                البصري على مستوى المملكة

                                            </span><br /><img src="/ksa.jpg" width="50" />
                                        </th>
                                        <!-- Group headers by municipalityName -->
                                        <th v-for="(municipality, index) in groupedDataIntishar"
                                            :key="'header-' + index"
                                            class="text-center">

                                            <div>{{ municipality[0].municipalityName }}</div><br />
                                            <v-img :src="municipality[0].logo" max-width="50" max-height="50"></v-img>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(option, ind) in groupedDataIntisharById" :key="'row-' + ind">
                                        <!-- Rows by ids, percentages -->
                                        <td>{{option[0].id}}<br />({{getAveragePercentageIntisharById(option[0].id)}}%)</td>
                                        <td v-for="(municipality, index) in groupedData"
                                            :key="'cell-' + index"
                                            class="text-center" :style="{ backgroundColor: getBackgroundColorIntishar(getAveragePercentageIntishar(municipality[0].municipalityName, option[0].id)), color: getTextColor(getAveragePercentageIntishar(municipality[0].municipalityName, option[0].id)) }">

                                            {{ getAveragePercentageIntishar(municipality[0].municipalityName, option[0].id) }}%

                                        </td>
                                    </tr>

                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" v-if="ridaAveragePerQuestion.length>0 || loadingridaAveragePerQuestion" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('RidaAverage') }}
                    <span class="icon">

                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingridaAveragePerQuestion"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingridaAveragePerQuestion" v-model="ridaAveragePerQuestion" :istriple="true" />
            </v-col>
            <v-col cols="12" v-if="intisharAveragePerQuestion.length>0 || loadingintisharAveragePerQuestion" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('IntisharAverage') }}
                    <span class="icon">

                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingintisharAveragePerQuestion"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingintisharAveragePerQuestion" v-model="intisharAveragePerQuestion" :istriple="true" :isintishar="true" />
            </v-col>
            <v-col cols="12" class="d-flex flex-column" v-if="ridaintisharSeries.filter(x=>x.data.length>0).length>0">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('PrevalenceOfVisualDistortionAndEvaluationOdEfforts') }}

                </div>
                <RidaIntisharLineChart :series="ridaintisharSeries" :categories="ridaintisharCategories" />
            </v-col>
            <v-col cols="12" class="d-flex flex-column" v-if="((ridaAveragePerMunicipality.length>0 && ridaAveragePerMunicipality.filter(x=>x.percentage>0).length>0) || loadingridaAveragePerMunicipality) && selectedMunicipalityItems.length==0">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('ResidentsAssessmentOfPrevalenceOfVisualDistortionAndEvaluationOfEfforts') }}

                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingridaAveragePerMunicipality"></v-skeleton-loader>
                <RidaIntisharPerMunicipality v-if="!loadingridaAveragePerMunicipality" v-model="ridaAveragePerMunicipality" />
            </v-col>
            <v-col cols="12" v-if="(satisfactionQuartersPercentages.length>0 && satisfactionQuartersPercentages.filter(z=>z>0).length>0) || loadingsatisfactionQuarters" class="d-flex flex-column">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionQuarters"></v-skeleton-loader>
                <SatisfactionQuartersChart :satisfactionQuartersLabels="satisfactionQuartersLabels" :title="$t('RidaQuarters')" :availableYears="availableYears" :satisfactionQuartersPercentages="satisfactionQuartersPercentages" v-if="!loadingsatisfactionQuarters" />
            </v-col>
            <v-col cols="12" v-if="(intisharQuartersPercentages.length>0 && intisharQuartersPercentages.filter(z=>z>0).length>0) || loadingintisharQuarters" class="d-flex flex-column">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingintisharQuarters"></v-skeleton-loader>
                <SatisfactionQuartersChart :satisfactionQuartersLabels="intisharQuartersLabels" :availableYears="intisharavailableYears" :title="$t('IntisharQuarters')" :satisfactionQuartersPercentages="intisharQuartersPercentages" v-if="!loadingintisharQuarters" />
            </v-col>
            <v-col cols="12" v-if="satisfactionTablePerQuestions3.length>0 || loadingsatisfactionTablePerQuestions3" class="d-flex flex-column">

                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('SatisfactionPerQuestion') }}
                    <span class="icon">
                        <table style="margin:0px;height:43.2px">
                            <tr>

                                <td>{{questionIconName(2)}}</td>
                                <td width="10"></td>
                                <td>
                                    <span class="icon">
                                        <v-icon color="white" size="40">{{ questionIcon(2) }}</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </table>
                    </span>
                </div>
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionTablePerQuestions3"></v-skeleton-loader>
                <SatisfactionPerQuestionChart v-if="!loadingsatisfactionTablePerQuestions3" v-model="satisfactionTablePerQuestions3" />
            </v-col>
            <v-col cols="12" class="d-flex flex-column">
                <template v-if="loadingsatisfactionData || (satisfactionData && satisfactionData.filter(z => z > 0).length > 0)">
                    
                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingsatisfactionData"></v-skeleton-loader>
                    <v-card class="elevation-5 mt-4 rounded-lg" v-if="!loadingsatisfactionData" style="height:100%">
                        <SatisfactionChart :satisfactionLabels="satisfactionLabels" :satisfactionLogos="satisfactionLogos" :satisfactionData="satisfactionData" title="" />
                    </v-card>
                </template>
            </v-col>

            <v-col cols="12" v-if="filteredDemographicsQuestions.length>0">
                <div class="chart-title d-flex justify-space-between align-center mt-0">
                    {{ $t('Demographics') }}

                </div>
                <v-card>
                    <v-card-text>
                        <v-row v-for="(row, rowIndex) in groupedQuestions" :key="'row-' + rowIndex">
                            <v-col v-for="q in row"
                                   :key="q.id"
                                   cols="rowIndex === 0 && groupedQuestions.length > 1 && groupedQuestions[0].length === 3 ? 'auto' : 6"
                                   d-flex
                                   class="d-flex flex-column">
                                <template v-if="q.resultTypeId === ResultTypes.Gender">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadinggenders"></v-skeleton-loader>
                                    <v-card color="#efeded" v-if="!loadinggenders" style="height: 100%">
                                        <v-card-text>
                                            <GenderChart v-model="q.genders" v-if="!loadinggenders && q.genders" />
                                        </v-card-text>
                                    </v-card>
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Nationality">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingnationalities"></v-skeleton-loader>
                                    <NationalityChart v-model="q.nationalities" v-if="!loadingnationalities && q.nationalities"></NationalityChart>
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Publication">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingpublications"></v-skeleton-loader>
                                    <PublicationChart v-model="q.publications" v-if="!loadingpublications && q.publications" />
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.AgeGroup">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, card-heading, image" v-if="loadingageGroup"></v-skeleton-loader>
                                    <AgeGroupChart v-model="q.ageGroup" v-if="!loadingageGroup && q.ageGroup" />
                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.EducationalLevel">
                                    <div class="chart-title mt-0">
                                        {{ language === 'ar' ? q.questionAr : q.questionEn }}
                                    </div>
                                    <v-skeleton-loader type="list-item-avatar, divider, card-heading, image" v-if="loadingeducationalLevel"></v-skeleton-loader>
                                    <EducationLevelChart v-model="q.educationalLevel" v-if="!loadingeducationalLevel && q.educationalLevel" />

                                </template>

                                <template v-else-if="q.resultTypeId === ResultTypes.Profession">
                                    <div class="chart-title mt-0">{{ language === 'ar' ? q.questionAr : q.questionEn }}</div>
                                    <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image" v-if="loadingprofessions"></v-skeleton-loader>
                                    <ProfessionsChart v-model="q.professions" v-if="!loadingprofessions && q.professions" />
                                </template>
                            </v-col>
                        </v-row>

                    </v-card-text>
                </v-card>
            </v-col>

        </v-row>
    </v-container>
</template>

<script>
    import AnalyticsService from '@/services/AnalyticsService'
    import StructuresService from '@/services/StructuresService'
    import SurveyService from '@/services/SurveyService'
    import { mapGetters } from 'vuex'
    import { AnalyticsTypes, ResultTypes } from '@/helpers/constants/enumerations.js'

    import SatisfactionChart from '@/components/controls/SatisfactionChart.vue'
    import MunicipalitiesChart from '@/components/charts/MunicipalitiesBar.vue'
    //import RegionsChart from '@/components/charts/Regions.vue'
    import GenderChart from '@/components/charts/GenderForExecutives.vue'
    import AgeGroupChart from '@/components/charts/AgeGroupForExecutives.vue'
    import EducationLevelChart from '@/components/charts/EducationLevelForExecutives.vue'
    import ProfessionsChart from '@/components/charts/ProfessionsForExecutives.vue'
    import PublicationChart from '@/components/charts/PublicationChart.vue'
    import CommunicationReasonChart from '@/components/charts/CommunicationReasonChart.vue'
    import PreCommunicationChart from '@/components/charts/PreCommunicationForExecutives.vue'
    import SpiderChart from '@/components/charts/SpiderChart.vue'
    import NationalityChart from '@/components/charts/Nationality.vue'
    import SatisfactionPerQuestionChart from '@/components/charts/SatisfactionPerQuestionForExecutives.vue'
    import RidaIntisharLineChart from '@/components/charts/RidaIntisharLineChart.vue'
    import RidaIntisharPerMunicipality from '@/components/charts/RidaIntisharPerMunicipality.vue'
    import SatisfactionQuartersChart from '@/components/controls/SatisfactionQuartersChart.vue'
    import { useStripHtml } from '@/helpers/common.js'
    export default {
        components: {
            MunicipalitiesChart, GenderChart, AgeGroupChart, SatisfactionQuartersChart, EducationLevelChart, ProfessionsChart, RidaIntisharPerMunicipality, /*RegionsChart,*/ PublicationChart, CommunicationReasonChart, PreCommunicationChart, SpiderChart, NationalityChart, SatisfactionPerQuestionChart, RidaIntisharLineChart, SatisfactionChart
        },
        data() {
            return {
                selectedMunicipalityItems: [],
                municipalityItems: [],
                ridaintisharSeries: [],
                ridaintisharCategories: [],
                ResultTypes: ResultTypes,
                questions: [],
                surveys: [],
                amanatData: [],
                satisfactionQuartersLabels: [],
                satisfactionQuartersPercentages: [],
                intisharQuartersLabels: [],
                intisharQuartersPercentages: [],
                selectedSurveys: 0,
                result: [],
                resultregion: [],
                genders: [],
                gendertitle:'',
                professions: [],
                maxStars: 5,
                nationalities: [],
                nationalitytitle:'',
                ageGroup: [],
                educationalLevel: [],
                publications: [],
                comreasons: [],
                precommunicationresults: [],
                precommunicationtitle:'',
                heatMap: [],
                spiderResults: [],
                heatMapIntishar: [],
                intisharAveragePerQuestion: [],
                ridaAveragePerQuestion: [],
                ridaAveragePerMunicipality:[],
                loading: false,
                loadingregion: false,
                loadinggenders: false,
                loadingprofessions: false,
                loadingnationalities: false,
                loadingageGroup: false,
                loadingeducationalLevel: false,
                loadingpublications: false,
                loadingcomreasons: false,
                loadingheatMap: false,
                loadingheatMapIntishar: false,
                loadingprecommunicationresults: false,
                loadingspiderResults: false,
                loadingridaAveragePerQuestion: false,
                loadingridaAveragePerMunicipality:false,
                loadingintisharAveragePerQuestion: false,
                agegrouptitle:'',
                data: [
                    { category: 'Task A', value: 10 },
                    { category: 'Task B', value: 35 },
                    { category: 'Task C', value: 65 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 3 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 13 },
                    { category: 'Task D', value: 5 },
                    { category: 'Task D', value: 90 },
                    { category: 'Task D', value: 25 },
                    { category: 'Task D', value: 75 },
                    { category: 'Task E', value: 42 }
                ],
                publicationstitle: '',
                comreasonstitle: '',
                spiderResultstitle: '',
                educationalLeveltitle: '',
                professionstitle: '',
                heatMaptitle: '',
                heatMapIntishartitle: '',
                yearMenu: false,
                quarterMenu: false,
                selectedYear: null,
                selectedQuarter: null,
                yearPicker: null,
                filterquestions: [],
                availableYears: [],
                intisharavailableYears:[],
                loadingsatisfactionQuarters: false,
                loadingintisharQuarters: false,
                maxDate: new Date().toISOString().split('T')[0],
                quarters: [{ value: 'q1', text: this.$t('QuarterOne') }, { value: 'q2', text: this.$t('QuarterTwo') }, { value: 'q3', text: this.$t('QuarterThree') }, { value: 'q4', text: this.$t('QuarterFour') }],
                satisfactionLabels: [],
                satisfactionLogos: [],
                satisfactionData: [],
                satisfactiontitle: '',
                loadingsatisfactionData: false,
                satisfactionTablePerQuestions3: [],
                loadingsatisfactionTablePerQuestions3: false,
                icons: [],
            }
        },
        computed: {
            ...mapGetters('user', ['loggedInUser', 'language']),
            isArabicLanguage() {
                return this.language == 'ar'
            },
            groupedQuestions() {
                let items = this.filteredDemographicsQuestions.filter(q =>
                    [ResultTypes.Publication, ResultTypes.Gender, ResultTypes.Nationality, ResultTypes.AgeGroup, ResultTypes.EducationalLevel, ResultTypes.Profession].includes(q.resultTypeId)
                )

                let result = []

                if (items.length >= 5) {
                    // If 6 or more, first row has 3, second row has 2, rest have 2 per row
                    result.push(items.slice(0, 3)) // First row: 3 items
                    result.push(items.slice(3, 5)) // Second row: 2 items
                    for (let i = 5; i < items.length; i += 2) {
                        result.push(items.slice(i, i + 2)) // Remaining items in pairs of 2
                    }
                } else {
                    // If less than 6, ensure every row has exactly 2 items
                    for (let i = 0; i < items.length; i += 2) {
                        result.push(items.slice(i, i + 2))
                    }
                }

                return result
            },
            groupedData() {
                // Group data by municipalityName
                const grouped = {}
                this.heatMap.forEach(item => {
                    if (!grouped[item.municipalityName]) {
                        grouped[item.municipalityName] = []
                    }
                    grouped[item.municipalityName].push(item)
                })
                return Object.values(grouped)
            },
            groupedDataById() {
                // Group data by municipalityName
                const grouped = {}
                this.heatMap.forEach(item => {
                    if (!grouped[item.id]) {
                        grouped[item.id] = []
                    }
                    grouped[item.id].push(item)
                })
                return Object.values(grouped)
            },
            groupedDataIntishar() {
                // Group data by municipalityName
                const grouped = {}
                this.heatMapIntishar.forEach(item => {
                    if (!grouped[item.municipalityName]) {
                        grouped[item.municipalityName] = []
                    }
                    grouped[item.municipalityName].push(item)
                })
                return Object.values(grouped)
            },

            groupedDataIntisharById() {
                // Group data by municipalityName
                const grouped = {}
                this.heatMapIntishar.forEach(item => {
                    if (!grouped[item.id]) {
                        grouped[item.id] = []
                    }
                    grouped[item.id].push(item)
                })
                return Object.values(grouped)
            },
            columSize() {
                return (resultTypeId) => {
                    var col = '6'
                    switch (resultTypeId) {
                        case this.ResultTypes.EducationalLevel:
                        case this.ResultTypes.AgeGroup:
                        case this.ResultTypes.Gender:
                        case this.ResultTypes.Nationality:
                        case this.ResultTypes.Publication:
                        case this.ResultTypes.Profession:
                        case this.ResultTypes.SignedQuestion:
                        case this.ResultTypes.CommunicationReason:
                        case this.ResultTypes.PreCommunication:
                            col = '6'
                            break
                        default:
                            col = '6'
                            break
                    }
                    return col
                }
            },
            questionIconName() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? (this.language == 'ar' ? result.iconTypeNameAr : result.iconTypeNameEn) : ''
                }
            },
            questionIcon() {
                return (id) => {
                    var result = this.icons.filter(x => x.id == id)[0]

                    return result ? result.icon : ''
                }
            },
            filteredQuestions() {
                // Filter questions to only include those with the relevant resultTypeId
                return this.questions ? this.questions.filter(
                    (q) =>
                        //(q.resultTypeId === this.ResultTypes.EducationalLevel && (q.educationalLevel && q.educationalLevel.filter(x => x.count > 0).length > 0 || this.loadingeducationalLevel)) ||
                        //(q.resultTypeId === this.ResultTypes.AgeGroup && (q.ageGroup && q.ageGroup.filter(x => x.count > 0).length > 0 || this.loadingageGroup)) ||
                        //(q.resultTypeId === this.ResultTypes.Gender && (q.genders && q.genders.filter(x => x.count > 0).length > 0 || this.loadinggenders)) ||
                        //(q.resultTypeId === this.ResultTypes.Nationality && (q.nationalities && q.nationalities.filter(x => x.count > 0).length > 0 || this.loadingnationalities)) ||
                        
                        //(q.resultTypeId === this.ResultTypes.Profession && (q.professions && q.professions.filter(x => x.count > 0).length > 0 || this.loadingprofessions)) ||
                        (q.resultTypeId === this.ResultTypes.CommunicationReason && (q.comreasons && q.comreasons.filter(x => x.count > 0).length > 0 || this.loadingcomreasons))
                        
                ) : []
            },
            filteredDemographicsQuestions() {
                // Filter questions to only include those with the relevant resultTypeId
                return this.questions ? this.questions.filter(
                    (q) =>
                        (q.resultTypeId === this.ResultTypes.Publication && (q.publications && q.publications.length > 0 || this.loadingpublications)) ||
                        (q.resultTypeId === this.ResultTypes.EducationalLevel && ((q.educationalLevel && q.educationalLevel.filter(x => x.count > 0).length > 0) || this.loadingeducationalLevel)) ||
                        (q.resultTypeId === this.ResultTypes.AgeGroup && (q.ageGroup && q.ageGroup.filter(x => x.count > 0).length > 0 || this.loadingageGroup)) ||
                        (q.resultTypeId === this.ResultTypes.Gender && ((q.genders && q.genders.filter(x => x.count > 0).length > 0) || this.loadinggenders)) ||
                        (q.resultTypeId === this.ResultTypes.Nationality && (q.nationalities && q.nationalities.filter(x => x.count > 0).length > 0 || this.loadingnationalities)) ||
                        (q.resultTypeId === this.ResultTypes.Profession && ((q.professions && q.professions.filter(x => x.count > 0).length > 0) || this.loadingprofessions))


                ) : []
            }
        },

        created() {
            this.listMunicipalities()
            this.listSurveys()
            this.listQuestionIcons()
            //this.listFilterQuestions()
        },

        methods: {
            cleanText(value) {
                return value ? useStripHtml(value) : value
            },

            async listQuestionIcons() {
                var result = await SurveyService.listQuestionIcons()
                this.icons = result.data
            },
            selectYear(year) {
                this.selectedYear = year
                this.yearMenu = false
                this.yearPicker = null
            },
            /*getAveragePercentage(municipalityGroup) {
      const totalPercentage = municipalityGroup.reduce((sum, item) => sum + item.percentage, 0)
      return (totalPercentage / municipalityGroup.length).toFixed(2) // Calculate average percentage
    },*/
            getAveragePercentage(municipalityName, id) {
                const groups = this.heatMap.filter(x => x.id === id && x.municipalityName === municipalityName)


                if (groups.length === 0) return 0 // Prevent division by zero if no matching groups

                const totalPercentage = groups.reduce((sum, item) => sum + item.percentage, 0)

                return Math.ceil(totalPercentage / groups.length)// Calculate and format average percentage
            },
            getAveragePercentageById(id) {
                const groups = this.heatMap.filter(x => x.id === id)


                if (groups.length === 0) return 0 // Prevent division by zero if no matching groups

                const totalPercentage = groups.reduce((sum, item) => sum + item.percentage, 0)

                return Math.round(totalPercentage / groups.length) // Calculate and format average percentage
            },
            getAveragePercentageIntishar(municipalityName, id) {
                const groups = this.heatMapIntishar.filter(x => x.id === id && x.municipalityName === municipalityName)


                if (groups.length === 0) return 0 // Prevent division by zero if no matching groups

                const totalPercentage = groups.reduce((sum, item) => sum + item.percentage, 0)

                return Math.ceil(totalPercentage / groups.length) // Calculate and format average percentage
            },
            getAveragePercentageIntisharById(id) {
                const groups = this.heatMapIntishar.filter(x => x.id === id)


                if (groups.length === 0) return 0 // Prevent division by zero if no matching groups

                const totalPercentage = groups.reduce((sum, item) => sum + item.percentage, 0)

                return Math.round(totalPercentage / groups.length) // Calculate and format average percentage
            },
            computedRating(percentage) {
                return (percentage / 100) * this.maxStars
            },

            removeItem(id) {
                const index = this.selectedMunicipalityItems.indexOf(id)
                if (index !== -1) {
                    this.selectedMunicipalityItems.splice(index, 1)
                }
            },

            selectAllItems() {
                this.selectedMunicipalityItems = this.municipalityItems.map(item => item.id)
            },

            clear() {
                this.selectedMunicipalityItems = []
                this.selectedSurveys = 0
                this.selectedYear = null
                this.selectedQuarter = null
            },
            getBackgroundColor(value) {
        if (value >= 85) return '#4B8B3B' // Dark Green  
        else if (value >= 80) return '#6CA55D' // Medium Green  
        else if (value >= 75) return '#86B96F' // Light Green  
        else if (value >= 70) return '#A2C48A' // Yellow-Green  
        else if (value >= 65) return '#C2D5A2' // Pale Green  
        else if (value >= 60) return '#E4E5B8' // Light Yellow  
        else return '#F5EAC3' // Very Light Yellow  
    },
            //getBackgroundColor(value) {
            //    const opacity = this.getOpacity(value)

            //    if (value >= 85) {
            //        return `rgba(140, 185, 106, ${opacity})` // Darkest green (85%)
            //    } else if (value >= 80) {
            //        return `rgba(148, 189, 111, ${opacity})` // Strong green (80-84%)
            //    } else if (value >= 75) {
            //        return `rgba(160, 195, 135, ${opacity})` // Medium green (75-79%)
            //    } else if (value >= 70) {
            //        return `rgba(193, 213, 143, ${opacity})` // Light green (70-74%)
            //    } else if (value >= 66) {
            //        return `rgba(200, 216, 148, ${opacity})` // Lightest green (66-69%)
            //    } else {
            //        return `rgba(225, 229, 166, ${opacity})` // Yellow-green for lower values (<66%)
            //    }
            //},
            //getBackgroundColor(value) {
            //    if (value > 66) {
            //        const opacity = this.getOpacity(value)
            //        return `rgba(138,184,104, ${opacity})`
            //    }
            //    else {
            //        var v = value
            //        const opacity = this.getOpacity(v)
            //        return `rgba(227,230,166, ${opacity})`
            //    }
            //},
            getBackgroundColorIntishar(value) {
        if (value >= 65) return '#E07A5F' // Dark Red-Orange  
        else if (value >= 60) return '#EA9871' // Medium Red-Orange  
        else if (value >= 55) return '#F2B08B' // Light Orange  
        else if (value >= 50) return '#F6CD9E' // Pale Orange  
        else if (value >= 45) return '#F7DEB3' // Light Yellow  
        else return '#FAECCC' // Very Light Yellow  
    },
            //getBackgroundColorIntishar(value) {
            //    if (value >= 60) {
            //        return `rgba(230, 97, 56, ${this.getOpacity(value)})` // Reddish for high values
            //    } else if (value >= 50) {
            //        return `rgba(253, 184, 99, ${this.getOpacity(value)})` // Orange/yellow for mid values
            //    } else {
            //        return `rgba(247, 233, 163, ${this.getOpacity(value)})` // Light yellow for low values
            //    }
                
            //},
            getTextColor(value) {
                return value > 50 ? '#000' : '#000'
            },
            getOpacity(value) {
                return (value / 100).toFixed(2)
            },

            listMunicipalities() {
                StructuresService.listMunicipalities().then((res) => {
                    if (res.data) {
                        this.municipalityItems = res.data.map(item => ({
                            id: item.municipalityID,
                            name: item.name
                        }))
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },

            listSurveys() {
                SurveyService.listSurveys(true, AnalyticsTypes.Baladi).then((res) => {
                    if (res.data) {
                        this.surveys = res.data
                    }
                }).catch(() => {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                }).finally(() => {
                    this.loading = false
                })
            },
            async listFilterQuestions() {
                let selectedSurveys = this.selectedSurveys
                var resp = await SurveyService.listFilterQuestions(AnalyticsTypes.Baladi, selectedSurveys)
                this.filterquestions = resp.data
            },
            async listRidaAveragePerMunicipality(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listRidaAveragePerMunicipality(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.ridaAveragePerMunicipality = resp.data
                
                this.loadingridaAveragePerMunicipality = false
            },
            async listRidaAveragePerQuestion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listRidaAveragePerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.ridaAveragePerQuestion = resp.data.filter(x => x.table.filter(z => z.count > 0).length > 0)
                var data = []
                for (var i = 0; i < this.ridaAveragePerQuestion.length; i++) {
                    var x = this.ridaAveragePerQuestion[i]
                    data.push(x.percentage)
                    if (this.ridaintisharCategories.filter(s => s == x.name).length == 0)
                        this.ridaintisharCategories.push(x.name)
                }
                this.ridaintisharSeries = this.ridaintisharSeries.map(x =>
                    x.name === 'معدل الرضا عن الجهود' ? { ...x, data: data } : x
                )
                //this.ridaintisharSeries.push({ name: 'معدل الرضا عن الجهود', data })
                this.loadingridaAveragePerQuestion = false
            },
            async listIntisharAveragePerQuestion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listIntisharAveragePerQuestion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.intisharAveragePerQuestion = resp.data.filter(x => x.table.filter(z => z.count > 0).length > 0)
                var data = []
                for (var i = 0; i < this.intisharAveragePerQuestion.length; i++) {
                    var x = this.intisharAveragePerQuestion[i]
                    data.push(x.percentage)
                    if (this.ridaintisharCategories.filter(s=>s == x.name).length==0)
                        this.ridaintisharCategories.push(x.name)
                }
                this.ridaintisharSeries = this.ridaintisharSeries.map(x =>
                    x.name === 'معدل انتشار مظاهر التشوه' ? { ...x, data: data } : x
                )
                //this.ridaintisharSeries.push({ name: 'معدل انتشار مظاهر التشوه', data })
                this.loadingintisharAveragePerQuestion = false
            },
            async listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.result = resp.data
                this.amanatData = []
                for (var i = 0; i < resp.data.length; i++) {
                    var x = resp.data[i]
                    this.amanatData.push({ value: x.count, label: x.municipalityName, percentage: x.percentage, logo: x.logo })
                }
                this.loading = false
            },
            async listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.resultregion = resp.data
                this.loadingregion = false
            },
            async listPublications(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listPublications(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.publications = resp.data.data
                q.publicationstitle = this.cleanText(resp.data.questionName)
                this.loadingpublications = false
            },
            async listCommunicationReasons(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listCommunicationReasons(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.comreasons = resp.data.data
                q.comreasonstitle = this.cleanText(resp.data.questionName)
                this.loadingcomreasons = false
            },
            async listPrecommunication(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listPrecommunication(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.precommunicationresults = resp.data.data
                this.loadingprecommunicationresults = false
                q.precommunicationtitle = this.cleanText(resp.data.questionName)
            },
            async listSpiderResults(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSpiderResults(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.spiderResults = resp.data.data
                this.spiderResultstitle = this.cleanText(resp.data.questionName)
                this.loadingspiderResults = false
            },
            async listGenders(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listGenders(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.genders = resp.data.results
                q.gendertitle = this.cleanText(resp.data.questionName)
                this.loadinggenders = false
            },
            async listEucationalLevels(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listEucationalLevels(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.educationalLevel = resp.data.data
                q.educationalLeveltitle = this.cleanText(resp.data.questionName)
                this.loadingeducationalLevel = false
            },
            async listProfessions(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listProfessions(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.professions = resp.data.data
                q.professionstitle = this.cleanText(resp.data.questionName)
                this.loadingprofessions = false
            },
            async listNationalities(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listNationalities(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.nationalities = resp.data.data
                q.nationalitytitle = this.cleanText(resp.data.questionName)
                this.loadingnationalities = false
            },
            async listAgeGroup(selectedSurveys, selectedMunicipalities, q) {
                var resp = await SurveyService.listAgeGroup(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions, q.id)
                q.ageGroup = resp.data.data
                q.agegrouptitle = this.cleanText(resp.data.questionName)
                this.loadingageGroup = false
            },
            async listHeatMap(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listHeatMap(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.heatMap = resp.data.data
                this.heatMaptitle = this.cleanText(resp.data.questionName)
                this.loadingheatMap = false
            },
            async listHeatMapIntishar(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listHeatMapIntishar(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.heatMapIntishar = resp.data.data
                this.heatMapIntishartitle = this.cleanText(resp.data.questionName)
                this.loadingheatMapIntishar = false
            },
            async listIntisharQuarters(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listIntisharQuarters(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.intisharQuartersLabels = []
                this.intisharQuartersPercentages = []
                this.intisharavailableYears = []
                var rows = resp.data
                rows.sort((a, b) => a.year - b.year)
                for (var i = 0; i < rows.length; i++) {
                    var x = rows[i]
                    var qlabel = this.quarters[x.quarter - 1].text + ' ' + x.year
                    this.intisharQuartersLabels.push(qlabel)
                    this.intisharQuartersPercentages.push(x.percentage)
                    this.intisharavailableYears.push(x.year)
                }
                this.loadingintisharQuarters = false
            },
            async listRidaQuarters(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listRidaQuarters(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.satisfactionQuartersLabels = []
                this.satisfactionQuartersPercentages = []
                this.availableYears = []
                var rows = resp.data
                rows.sort((a, b) => a.year - b.year)
                for (var i = 0; i < rows.length; i++) {
                    var x = rows[i]
                    var qlabel = this.quarters[x.quarter - 1].text + ' ' + x.year
                    this.satisfactionQuartersLabels.push(qlabel)
                    this.satisfactionQuartersPercentages.push(x.percentage)
                    this.availableYears.push(x.year)
                }
                this.loadingsatisfactionQuarters = false
            },
            async listAnalyticsQuestions(selectedSurveys) {
                var result = await SurveyService.listAnalyticsQuestions(selectedSurveys, AnalyticsTypes.Baladi)
                this.questions = (await result.data).map(q => ({
                    ...q,
                    questionAr: this.cleanText(q.questionAr),
                    questionEn: this.cleanText(q.questionEn),
                    analyticsNameAr: this.cleanText(q.analyticsNameAr),
                    analyticsNameEn: this.cleanText(q.analyticsNameEn)
                }))
            },

            selectMunicipality(municipality) {
                var found = this.municipalityItems.filter(x => x.name == municipality.label)
                if (found.length > 0) {
                    var item = found[0]
                    this.selectedMunicipalityItems = []
                    this.selectedMunicipalityItems.push(item.id)
                    this.loadDemographics()
                }
            },
            async listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.satisfactionTablePerQuestions3 = resp.data
                this.loadingsatisfactionTablePerQuestions3 = false
            }, 
            async listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities) {
                var resp = await SurveyService.listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities, this.selectedYear, this.selectedQuarter, AnalyticsTypes.Baladi, this.filterquestions)
                this.satisfactionLabels = []
                this.satisfactionLogos = []
                this.satisfactionData = []
                this.satisfactiontitle = this.cleanText(resp.data.questionName)
                for (var i = 0; i < resp.data.data.length; i++) {
                    var x = resp.data.data[i]
                    this.satisfactionLabels.push('')
                    this.satisfactionLogos.push(x.logo)
                    this.satisfactionData.push(x.percentage)
                }
                this.loadingsatisfactionData = false
            },
            async loadDemographics() {

                if (this.selectedSurveys) {
                try {
                    let selectedSurveys = this.selectedSurveys
                    let selectedMunicipalities = this.selectedMunicipalityItems
                    this.loading = true
                    this.loadinggenders = true
                    this.loadingprofessions = true
                    this.loadingeducationalLevel = true
                    this.loadingnationalities = true
                    this.loadingageGroup = true
                    this.loadingpublications = true
                    this.loadingcomreasons = true
                    this.loadingheatMap = true
                    this.loadingheatMapIntishar = true
                    this.loadingregion = true
                    this.loadingprecommunicationresults = true
                    this.loadingspiderResults = true
                    this.loadingridaAveragePerQuestion = true
                    this.loadingridaAveragePerMunicipality = true
                    this.loadingintisharAveragePerQuestion = true
                    this.loadingsatisfactionData = true
                    await this.listAnalyticsQuestions(selectedSurveys)
                    this.filteredQuestions.map((q) => {
                        switch (q.resultTypeId) {
                            
                            
                            
                            case this.ResultTypes.CommunicationReason:
                                this.listCommunicationReasons(selectedSurveys, selectedMunicipalities, q)
                                break
                            case this.ResultTypes.PreCommunication:
                                this.listPrecommunication(selectedSurveys, selectedMunicipalities, q)
                                break
                        }
                    })
                    this.filteredDemographicsQuestions.map((q) => {

                        switch (q.resultTypeId) {
                            case this.ResultTypes.Publication:
                                this.listPublications(selectedSurveys, selectedMunicipalities, q)
                                break
                            case this.ResultTypes.EducationalLevel:
                                this.listEucationalLevels(selectedSurveys, selectedMunicipalities, q)
                                break
                            case this.ResultTypes.AgeGroup:
                                this.listAgeGroup(selectedSurveys, selectedMunicipalities, q)
                                break
                            case this.ResultTypes.Gender:
                                this.listGenders(selectedSurveys, selectedMunicipalities, q)
                                break
                            case this.ResultTypes.Nationality:
                                this.listNationalities(selectedSurveys, selectedMunicipalities, q)
                                break

                            case this.ResultTypes.Profession:
                                this.listProfessions(selectedSurveys, selectedMunicipalities, q)
                                break
                        }
                    })
                    this.ridaintisharSeries = []
                    this.ridaintisharSeries.push({ name: 'معدل الرضا عن الجهود', data:[] })
                    this.ridaintisharSeries.push({ name: 'معدل انتشار مظاهر التشوه', data:[] })
                    this.listSurveyMainAnalytics(selectedSurveys, selectedMunicipalities)
                    //this.listSurveyAnalyticsPerRegion(selectedSurveys, selectedMunicipalities)
                    this.listRidaAveragePerQuestion(selectedSurveys, selectedMunicipalities)
                    this.listRidaAveragePerMunicipality(selectedSurveys, selectedMunicipalities)
                    this.listIntisharAveragePerQuestion(selectedSurveys, selectedMunicipalities)
                    this.listHeatMap(selectedSurveys, selectedMunicipalities)
                    this.listHeatMapIntishar(selectedSurveys, selectedMunicipalities)
                    this.listSpiderResults(selectedSurveys, selectedMunicipalities)
                    this.listIntisharQuarters(selectedSurveys, selectedMunicipalities)
                    this.listRidaQuarters(selectedSurveys, selectedMunicipalities)
                    this.listSakaniSatisfactionfromCSAT3(selectedSurveys, selectedMunicipalities)
                    this.listSakaniSatisfactionPerQuestion3(selectedSurveys, selectedMunicipalities)
                }
                catch (ex) {
                    this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    this.loading = false
                    this.loadinggenders = false
                    this.loadingprofessions = false
                    this.loadingeducationalLevel = false
                    this.loadingnationalities = false
                    this.loadingageGroup = false
                    this.loadingpublications = false
                    this.loadingcomreasons = false
                    this.loadingheatMap = false
                    this.loadingheatMapIntishar = false
                    this.loadingregion = false
                    this.loadingprecommunicationresults = false
                    this.loadingspiderResults = false
                    this.loadingridaAveragePerQuestion = false
                    this.loadingridaAveragePerMunicipality = false
                    this.loadingintisharAveragePerQuestion = false
                    this.loadingsatisfactionData = false
                    }
                }
                else {
                    this.$root.$notification(this.$t('PleaseChooseSurvey'), 'error')
                }
            },
        },
    }
</script>

<style scoped>
    .ksa-bg {
        background: url(../assets/images/KSA.png) no-repeat center
    }

    .pink-color {
        color: #ff99cc !important
    }

    .amber-color {
        color: #bf9000 !important
    }

    .green-color {
        color: #6ba786 !important
    }
</style>